import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import {
  FaArrowLeft,
  FaGlobe,
  FaCheckCircle,
  FaHandshake,
  FaTruck,
  FaDollarSign,
  FaShip,
  FaIndustry,
  FaBoxes,
  FaUserFriends,
  FaArrowRight,
} from "react-icons/fa";

import {
  GiSewingNeedle,
  GiHemp,
  GiWool,
} from "react-icons/gi";

/* ============================================================

   LOCAL IMAGES

   All images are imported from src/logos

   ============================================================ */



import kmkLogo from '../logos/YarnTrading/tradinglogo.png';



import viscoseYarn from '../logos/YarnTrading/yarntrading1.png';

import juteYarn from '../logos/YarnTrading/yarntrading2.png';

import warehouse from '../logos/YarnTrading/yarntrading3.png';



import viscoseProduct from '../logos/YarnTrading/yarntrading4.png';

import juteProduct from '../logos/YarnTrading/yarntrading5.png';



import footerYarn from '../logos/YarnTrading/yarntrading6.png';

import footerJute from '../logos/YarnTrading/yarntrading7.png';

import footerLeaves from '../logos/YarnTrading/yarntrading6.png';

import worldMap from '../logos/YarnTrading/yarntrading7.png';

export default function YarnTrading() {

  const navigate = useNavigate();

  const sectionsRef = useRef([]);

  /* ==========================================================
     SCROLL REVEAL ANIMATION
     ========================================================== */

  useEffect(() => {

    const observer = new IntersectionObserver(
      (entries) => {

        entries.forEach((entry) => {

          if (entry.isIntersecting) {
            entry.target.classList.add("yk-visible");
          }

        });

      },
      {
        threshold: 0.12,
      }
    );

    sectionsRef.current.forEach((section) => {

      if (section) {
        observer.observe(section);
      }

    });

    return () => observer.disconnect();

  }, []);


  const addSectionRef = (element) => {

    if (
      element &&
      !sectionsRef.current.includes(element)
    ) {
      sectionsRef.current.push(element);
    }

  };


  return (
    <div className="yk-page">

      {/* ======================================================
          GLOBAL BACKGROUND EFFECT
          ====================================================== */}

      <div className="yk-background-grid" />


      {/* ======================================================
          TOP NAVIGATION
          ====================================================== */}

      <div className="yk-topbar">

        <div className="yk-topbar-inner">

          <button
            className="yk-back-btn"
            onClick={() => navigate("/")}
          >

            <span className="yk-back-icon">
              <FaArrowLeft />
            </span>

            <span>
              Back to All Sectors
            </span>

          </button>


          <div className="yk-topbar-label">

            <span className="yk-status-dot" />

            YARN TRADING DIVISION

          </div>

        </div>

      </div>


      {/* ======================================================
          FULL WIDTH HERO
          ====================================================== */}

      <section className="yk-hero">

        <div className="yk-hero-overlay" />

        <div className="yk-hero-content">

          {/* LEFT BRAND */}

          <div className="yk-hero-brand">

            <div className="yk-logo-ring">

              <div className="yk-logo-ring-inner">

                <img
                  src={kmkLogo}
                  alt="KMK Logo"
                />

              </div>

            </div>


            <div className="yk-brand-name">

              <div className="yk-brand-small">
                KH MUTAHIR KALIM
              </div>

              <div className="yk-brand-line" />

              <div className="yk-brand-title">
                YARN TRADING
              </div>

              <div className="yk-brand-title">
                DIVISION
              </div>

              <div className="yk-brand-subtitle">
                LEGACY IN TEXTILES
              </div>

            </div>

          </div>


          {/* RIGHT HERO TEXT */}

          <div className="yk-hero-text">

            <div className="yk-eyebrow">

              <span />

              SINCE 1964

              <span />

            </div>


            <h1>

              Driven by
              <strong> Market Insight.</strong>

              <br />

              Powered by
              <strong> Reliable Supply.</strong>

            </h1>


            <p>

              Strategic sourcing, dependable supply chains,
              and reliable yarn solutions for Pakistan's
              textile and carpet industries.

            </p>


            <div className="yk-hero-actions">

              <button
                onClick={() => {
                  document
                    .getElementById("yk-products")
                    ?.scrollIntoView({
                      behavior: "smooth",
                    });
                }}
                className="yk-primary-btn"
              >

                Explore Products

                <FaArrowRight />

              </button>


              <button
                onClick={() => {
                  document
                    .getElementById("yk-about")
                    ?.scrollIntoView({
                      behavior: "smooth",
                    });
                }}
                className="yk-secondary-btn"
              >

                Discover KMK

              </button>

            </div>

          </div>

        </div>


        {/* HERO BOTTOM */}

        <div className="yk-hero-bottom">

          <div>
            <strong>60+</strong>
            <span>Years Experience</span>
          </div>

          <div>
            <strong>2</strong>
            <span>Core Yarn Categories</span>
          </div>

          <div>
            <strong>Nationwide</strong>
            <span>Distribution Reach</span>
          </div>

          <div>
            <strong>Global</strong>
            <span>Sourcing Network</span>
          </div>

        </div>

      </section>


      {/* ======================================================
          MAIN CONTENT
          ====================================================== */}

      <main className="yk-main">


        {/* ====================================================
            IMAGE SHOWCASE
            ==================================================== */}

        <section
          ref={addSectionRef}
          className="yk-showcase yk-reveal"
        >

          <div className="yk-showcase-heading">

            <span className="yk-gold-line" />

            <div>

              <span className="yk-mini-label">
                OUR SUPPLY NETWORK
              </span>

              <h2>
                Reliable Yarn.
                <br />
                <span>Reliable Partnership.</span>
              </h2>

            </div>

            <span className="yk-gold-line" />

          </div>


          <div className="yk-image-grid">

            {/* MAIN */}

            <div className="yk-image-card yk-image-large">

              <img
                src={viscoseYarn}
                alt="Premium Viscose Yarn"
              />

              <div className="yk-image-gradient" />

              <div className="yk-image-content">

                <span>
                  PREMIUM QUALITY
                </span>

                <h3>
                  Viscose Yarn
                </h3>

              </div>

            </div>


            {/* JUTE */}

            <div className="yk-image-card">

              <img
                src={juteYarn}
                alt="Natural Jute Yarn"
              />

              <div className="yk-image-gradient" />

              <div className="yk-image-content">

                <span>
                  NATURAL FIBER
                </span>

                <h3>
                  Jute Yarn
                </h3>

              </div>

            </div>


            {/* WAREHOUSE */}

            <div className="yk-image-card">

              <img
                src={warehouse}
                alt="Warehouse Supply"
              />

              <div className="yk-image-gradient" />

              <div className="yk-image-content">

                <span>
                  SUPPLY NETWORK
                </span>

                <h3>
                  Nationwide Reach
                </h3>

              </div>

            </div>

          </div>

        </section>


        {/* ====================================================
            ABOUT
            ==================================================== */}

        <section
          id="yk-about"
          ref={addSectionRef}
          className="yk-about-section yk-reveal"
        >

          <div className="yk-about-left">

            <div className="yk-section-label">

              <span />

              ABOUT THE DIVISION

            </div>


            <h2>

              Connecting
              <span>
                Global Yarn
              </span>
              to Local Industry.

            </h2>


            <p>

              Kh Mutahir Kalim (KMK) represents the group's
              dedicated yarn trading arm, specializing in the
              sourcing, import, and distribution of high-quality
              viscose and jute yarns.

            </p>


            <p>

              With decades of market experience and strong
              global sourcing channels, KMK plays a vital role
              in supplying consistent, reliable, and competitively
              priced yarn solutions to Pakistan's textile and
              carpet industries.

            </p>


            <div className="yk-about-highlight">

              <div className="yk-highlight-icon">
                <FaHandshake />
              </div>

              <div>

                <strong>
                  Strategic Sourcing
                </strong>

                <span>
                  Market expertise with dependable supply chains.
                </span>

              </div>

            </div>

          </div>


          <div className="yk-about-right">

            <div className="yk-about-stat">

              <FaGlobe />

              <strong>
                GLOBAL
              </strong>

              <span>
                SOURCING
              </span>

            </div>


            <div className="yk-about-stat">

              <FaTruck />

              <strong>
                RELIABLE
              </strong>

              <span>
                DELIVERY
              </span>

            </div>


            <div className="yk-about-stat">

              <FaDollarSign />

              <strong>
                COMPETITIVE
              </strong>

              <span>
                PRICING
              </span>

            </div>


            <div className="yk-about-stat">

              <FaCheckCircle />

              <strong>
                CONSISTENT
              </strong>

              <span>
                QUALITY
              </span>

            </div>

          </div>

        </section>


        {/* ====================================================
            PRODUCTS
            ==================================================== */}

        <section
          id="yk-products"
          ref={addSectionRef}
          className="yk-products-section yk-reveal"
        >

          <div className="yk-section-heading-center">

            <div className="yk-section-label">

              <span />
              OUR PRODUCT FOCUS
              <span />

            </div>

            <h2>
              Yarn Solutions Built
              <span> Around Industry Needs.</span>
            </h2>

          </div>


          <div className="yk-products-grid">


            {/* ==================================================
                VISCOSE
                ================================================== */}

            <article className="yk-product-card">

              <div className="yk-product-image">

                <img
                  src={viscoseProduct}
                  alt="Viscose Yarn"
                />

                <div className="yk-product-overlay">

                  <span>
                    PRODUCT 01
                  </span>

                </div>

              </div>


              <div className="yk-product-body">

                <div className="yk-product-number">
                  01
                </div>

                <h3>
                  Viscose Yarn
                </h3>

                <p>
                  Soft, smooth and high-quality yarn
                  designed for modern textile applications.
                </p>


                <div className="yk-product-features">

                  <div>
                    <FaCheckCircle />
                    Denier Range: 30D – 150D
                  </div>

                  <div>
                    <FaCheckCircle />
                    Soft & high-quality finish
                  </div>

                  <div>
                    <FaCheckCircle />
                    Fashion & blended textiles
                  </div>

                </div>

              </div>

            </article>


            {/* ==================================================
                JUTE
                ================================================== */}

            <article className="yk-product-card">

              <div className="yk-product-image">

                <img
                  src={juteProduct}
                  alt="Jute Yarn"
                />

                <div className="yk-product-overlay">

                  <span>
                    PRODUCT 02
                  </span>

                </div>

              </div>


              <div className="yk-product-body">

                <div className="yk-product-number">
                  02
                </div>

                <h3>
                  Jute Yarn
                </h3>

                <p>
                  Strong, natural and eco-friendly fiber
                  for carpet and industrial applications.
                </p>


                <div className="yk-product-features">

                  <div>
                    <FaCheckCircle />
                    Natural eco-friendly fiber
                  </div>

                  <div>
                    <FaCheckCircle />
                    Strong & durable
                  </div>

                  <div>
                    <FaCheckCircle />
                    Carpet & industrial textiles
                  </div>

                </div>

              </div>

            </article>

          </div>

        </section>


        {/* ====================================================
            ROLE
            ==================================================== */}

        <section
          ref={addSectionRef}
          className="yk-role-section yk-reveal"
        >

          <div className="yk-role-heading">

            <span>
              OUR ROLE
            </span>

            <h2>
              Bridging Global Producers
              <br />
              With Local Demand.
            </h2>

          </div>


          <div className="yk-role-description">

            <p>

              We bridge the gap between international yarn
              producers and local industry demand, ensuring
              the right yarn is available when and where it
              is needed.

            </p>

          </div>


          <div className="yk-role-grid">


            <div className="yk-role-item">

              <FaGlobe />

              <strong>
                GLOBAL SOURCING
              </strong>

              <span>
                Established international sourcing network
              </span>

            </div>


            <div className="yk-role-item">

              <FaDollarSign />

              <strong>
                COMPETITIVE PRICING
              </strong>

              <span>
                Market-driven and competitive solutions
              </span>

            </div>


            <div className="yk-role-item">

              <FaShip />

              <strong>
                IMPORT CHANNELS
              </strong>

              <span>
                Reliable international import channels
              </span>

            </div>


            <div className="yk-role-item">

              <FaTruck />

              <strong>
                SUPPLY MANAGEMENT
              </strong>

              <span>
                Strong nationwide supply chain
              </span>

            </div>

          </div>

        </section>


        {/* ====================================================
            STRENGTHS
            ==================================================== */}

        <section
          ref={addSectionRef}
          className="yk-strength-section yk-reveal"
        >


          <div className="yk-strength-left">

            <div className="yk-section-label">

              <span />

              OUR CORE STRENGTHS

            </div>


            <h2>
              Built on
              <span>
                Trust, Experience
              </span>
              & Consistency.
            </h2>


            <p>

              Our strength is not simply moving yarn.
              It is understanding the market, anticipating
              demand and maintaining dependable relationships
              throughout the supply chain.

            </p>

          </div>


          <div className="yk-strength-list">


            <div className="yk-strength-row">

              <div className="yk-strength-icon">
                <FaGlobe />
              </div>

              <div>

                <strong>
                  Established Global Sourcing Network
                </strong>

                <span>
                  Strong international sourcing relationships.
                </span>

              </div>

            </div>


            <div className="yk-strength-row">

              <div className="yk-strength-icon">
                <GiSewingNeedle />
              </div>

              <div>

                <strong>
                  Deep Yarn Market Understanding
                </strong>

                <span>
                  Knowledge built through years of industry experience.
                </span>

              </div>

            </div>


            <div className="yk-strength-row">

              <div className="yk-strength-icon">
                <FaHandshake />
              </div>

              <div>

                <strong>
                  Strong Supplier Relationships
                </strong>

                <span>
                  Trusted partnerships across the supply chain.
                </span>

              </div>

            </div>


            <div className="yk-strength-row">

              <div className="yk-strength-icon">
                <FaTruck />
              </div>

              <div>

                <strong>
                  Nationwide Distribution Reach
                </strong>

                <span>
                  Reliable availability across Pakistan.
                </span>

              </div>

            </div>


            <div className="yk-strength-row">

              <div className="yk-strength-icon">
                <FaCheckCircle />
              </div>

              <div>

                <strong>
                  Consistency in Quality & Delivery
                </strong>

                <span>
                  Reliable products delivered on schedule.
                </span>

              </div>

            </div>

          </div>

        </section>


        {/* ====================================================
            INDUSTRIES
            ==================================================== */}

        <section
          ref={addSectionRef}
          className="yk-industries-section yk-reveal"
        >

          <div className="yk-section-heading-center">

            <div className="yk-section-label">

              <span />

              INDUSTRIES WE SERVE

              <span />

            </div>


            <h2>
              Supporting Industries
              <span> Across the Supply Chain.</span>
            </h2>

          </div>


          <div className="yk-industry-grid">


            <div className="yk-industry-card">

              <div className="yk-industry-icon">
                <GiHemp />
              </div>

              <strong>
                CARPET
              </strong>

              <span>
                MANUFACTURERS
              </span>

            </div>


            <div className="yk-industry-card">

              <div className="yk-industry-icon">
                <FaIndustry />
              </div>

              <strong>
                TEXTILE
              </strong>

              <span>
                MILLS
              </span>

            </div>


            <div className="yk-industry-card">

              <div className="yk-industry-icon">
                <GiWool />
              </div>

              <strong>
                FABRIC
              </strong>

              <span>
                PRODUCERS
              </span>

            </div>


            <div className="yk-industry-card">

              <div className="yk-industry-icon">
                <FaGlobe />
              </div>

              <strong>
                EXPORT
              </strong>

              <span>
                HOUSES
              </span>

            </div>


            <div className="yk-industry-card">

              <div className="yk-industry-icon">
                <FaUserFriends />
              </div>

              <strong>
                TRADERS
              </strong>

              <span>
                & WHOLESALERS
              </span>

            </div>

          </div>

        </section>


      </main>


      {/* ======================================================
          FULL WIDTH CTA
          ====================================================== */}

      <section className="yk-final-banner">

        <div className="yk-final-decoration-left">

          <img
            src={footerYarn}
            alt=""
          />

          <img
            src={footerJute}
            alt=""
          />

        </div>


        <div className="yk-final-content">

          <span className="yk-final-small">
            KMK — KH MUTAHIR KALIM
          </span>

          <h2>

            DELIVERING THE RIGHT YARN,

            <br />

            <strong>
              AT THE RIGHT TIME.
            </strong>

          </h2>

          <p>
            Complete reliability from source to industry.
          </p>

        </div>


        <div className="yk-final-decoration-right">

          <img
            src={footerLeaves}
            alt=""
          />

          <img
            src={footerJute}
            alt=""
          />

        </div>

      </section>


      {/* ======================================================
          FOOTER
          ====================================================== */}

      <footer className="yk-footer">

        <div className="yk-footer-inner">


          <div className="yk-footer-number">
            08
          </div>


          <div className="yk-footer-company">

            <strong>
              ASHRAF GROUP OF INDUSTRIES
            </strong>

            <span>
              Building Legacy. Powering the Future.
            </span>

          </div>


          <div className="yk-footer-divider" />


          <a
            href="https://www.ashrafiafood.com"
            target="_blank"
            rel="noopener noreferrer"
            className="yk-footer-link"
          >

            <FaGlobe />

            <span>
              www.ashrafiafood.com
            </span>

          </a>


          <img
            src={worldMap}
            alt=""
            className="yk-footer-map"
          />

        </div>

      </footer>


      {/* ======================================================
          COMPLETE CSS
          ====================================================== */}

      <style>{`

        /* =====================================================
           RESET
           ===================================================== */

        * {
          box-sizing: border-box;
        }


        html {
          scroll-behavior: smooth;
        }


        body {
          margin: 0;
          padding: 0;
        }


        /* =====================================================
           COLORS
           ===================================================== */

        .yk-page {

          --navy: #071d36;
          --navy-light: #0c2c4d;
          --gold: #c59a4b;
          --gold-light: #e1bd78;
          --cream: #f7f3ea;
          --white: #ffffff;
          --text: #27313b;
          --muted: #66717d;

          width: 100%;
          min-height: 100vh;

          background:
            radial-gradient(
              circle at 10% 10%,
              rgba(197,154,75,.08),
              transparent 25%
            ),
            radial-gradient(
              circle at 90% 80%,
              rgba(7,29,54,.06),
              transparent 25%
            ),
            #f4f1ea;

          color: var(--text);

          font-family:
            Georgia,
            "Times New Roman",
            serif;

          overflow-x: hidden;

        }


        /* =====================================================
           BACKGROUND GRID
           ===================================================== */

        .yk-background-grid {

          position: fixed;

          inset: 0;

          pointer-events: none;

          opacity: .18;

          background-image:
            linear-gradient(
              rgba(7,29,54,.04) 1px,
              transparent 1px
            ),
            linear-gradient(
              90deg,
              rgba(7,29,54,.04) 1px,
              transparent 1px
            );

          background-size: 40px 40px;

          z-index: 0;

        }


        /* =====================================================
           TOP BAR
           ===================================================== */

        .yk-topbar {

          position: sticky;

          top: 0;

          z-index: 100;

          width: 100%;

          background:
            rgba(7,29,54,.96);

          backdrop-filter:
            blur(15px);

          border-bottom:
            1px solid
            rgba(197,154,75,.3);

        }


        .yk-topbar-inner {

          width: 100%;

          max-width: 1600px;

          margin: auto;

          padding:
            11px
            clamp(18px,4vw,60px);

          display: flex;

          justify-content:
            space-between;

          align-items: center;

        }


        .yk-back-btn {

          border: 1px solid
            rgba(197,154,75,.55);

          background: transparent;

          color: white;

          padding:
            8px 14px;

          border-radius: 4px;

          display: flex;

          align-items: center;

          gap: 8px;

          font-size: 12px;

          cursor: pointer;

          transition:
            all .3s ease;

        }


        .yk-back-btn:hover {

          background:
            var(--gold);

          border-color:
            var(--gold);

          color:
            var(--navy);

          transform:
            translateX(-3px);

        }


        .yk-back-icon {

          display: flex;

        }


        .yk-topbar-label {

          color:
            rgba(255,255,255,.8);

          font-size: 10px;

          letter-spacing: 2px;

          display: flex;

          align-items: center;

          gap: 8px;

        }


        .yk-status-dot {

          width: 7px;

          height: 7px;

          background:
            var(--gold);

          border-radius: 50%;

          box-shadow:
            0 0 0 5px
            rgba(197,154,75,.1);

          animation:
            ykPulse 2s infinite;

        }


        @keyframes ykPulse {

          0%,100% {
            box-shadow:
              0 0 0 3px
              rgba(197,154,75,.1);
          }

          50% {
            box-shadow:
              0 0 0 8px
              rgba(197,154,75,.02);
          }

        }


        /* =====================================================
           HERO
           ===================================================== */

        .yk-hero {

          position: relative;

          width: 100%;

          min-height: 690px;

          display: flex;

          flex-direction: column;

          justify-content: center;

          overflow: hidden;

          background:
            linear-gradient(
              115deg,
              rgba(7,29,54,.98) 0%,
              rgba(7,29,54,.94) 42%,
              rgba(7,29,54,.75) 100%
            );

        }


        .yk-hero::before {

          content: "";

          position: absolute;

          inset: 0;

          background:
            linear-gradient(
              90deg,
              rgba(7,29,54,.98) 0%,
              rgba(7,29,54,.75) 42%,
              rgba(7,29,54,.15) 100%
            );

          z-index: 1;

        }


        .yk-hero::after {

          content: "";

          position: absolute;

          width: 600px;

          height: 600px;

          right: -200px;

          top: -220px;

          border:
            1px solid
            rgba(197,154,75,.25);

          border-radius: 50%;

          box-shadow:
            0 0 0 80px
            rgba(197,154,75,.03),
            0 0 0 160px
            rgba(197,154,75,.02);

          animation:
            ykRotate 25s linear infinite;

        }


        @keyframes ykRotate {

          from {
            transform:
              rotate(0deg);
          }

          to {
            transform:
              rotate(360deg);
          }

        }


        .yk-hero-overlay {

          position: absolute;

          inset: 0;

          background:
            radial-gradient(
              circle at 80% 50%,
              rgba(197,154,75,.12),
              transparent 35%
            );

          z-index: 1;

        }


        .yk-hero-content {

          position: relative;

          z-index: 3;

          width: 100%;

          max-width: 1450px;

          margin: auto;

          padding:
            80px
            clamp(25px,6vw,100px);

          display: grid;

          grid-template-columns:
            1fr
            1.35fr;

          gap: 80px;

          align-items: center;

        }


        /* =====================================================
           HERO BRAND
           ===================================================== */

        .yk-hero-brand {

          display: flex;

          align-items: center;

          gap: 30px;

          animation:
            ykHeroLeft 1s ease forwards;

        }


        @keyframes ykHeroLeft {

          from {
            opacity: 0;
            transform:
              translateX(-40px);
          }

          to {
            opacity: 1;
            transform:
              translateX(0);
          }

        }


        .yk-logo-ring {

          width: 260px;

          height: 260px;

          border-radius: 50%;

          border:
            1px solid
            var(--gold);

          padding: 10px;

          display: flex;

          align-items: center;

          justify-content: center;

          box-shadow:
            0 0 0 8px
            rgba(197,154,75,.05),
            0 20px 50px
            rgba(0,0,0,.25);

          animation:
            ykLogoFloat 5s ease-in-out infinite;

        }


        @keyframes ykLogoFloat {

          0%,100% {
            transform:
              translateY(0);
          }

          50% {
            transform:
              translateY(-8px);
          }

        }


        .yk-logo-ring-inner {

          width: 100%;

          height: 100%;

          border-radius: 50%;

          background:
            #f7f4ed;

          display: flex;

          align-items: center;

          justify-content: center;

          overflow: hidden;

        }


        .yk-logo-ring-inner img {

          width: 92%;

          height: 92%;

          object-fit: contain;

        }


        .yk-brand-name {

          color: white;

        }


        .yk-brand-small {

          font-size: 14px;

          letter-spacing: 3px;

          color:
            var(--gold-light);

          margin-bottom: 8px;

        }


        .yk-brand-line {

          width: 100px;

          height: 1px;

          background:
            var(--gold);

          margin-bottom: 12px;

        }


        .yk-brand-title {

          font-size: 27px;

          line-height: 1.1;

          letter-spacing: 2px;

          font-weight: bold;

        }


        .yk-brand-subtitle {

          margin-top: 16px;

          font-size: 10px;

          letter-spacing: 4px;

          color:
            var(--gold-light);

        }


        /* =====================================================
           HERO TEXT
           ===================================================== */

        .yk-hero-text {

          max-width: 750px;

          animation:
            ykHeroRight 1s .15s ease forwards;

          opacity: 0;

        }


        @keyframes ykHeroRight {

          from {

            opacity: 0;

            transform:
              translateY(30px);

          }

          to {

            opacity: 1;

            transform:
              translateY(0);

          }

        }


        .yk-eyebrow {

          display: flex;

          align-items: center;

          gap: 12px;

          color:
            var(--gold-light);

          font-size: 11px;

          letter-spacing: 4px;

          margin-bottom: 20px;

        }


        .yk-eyebrow span {

          width: 45px;

          height: 1px;

          background:
            var(--gold);

        }


        .yk-hero-text h1 {

          margin: 0;

          color: white;

          font-size:
            clamp(38px,5vw,72px);

          line-height: 1.08;

          font-weight: normal;

        }


        .yk-hero-text h1 strong {

          color:
            var(--gold-light);

          font-weight: normal;

        }


        .yk-hero-text p {

          max-width: 620px;

          color:
            rgba(255,255,255,.72);

          font-family:
            Arial,
            sans-serif;

          font-size: 15px;

          line-height: 1.8;

          margin:
            25px 0 30px;

        }


        .yk-hero-actions {

          display: flex;

          gap: 12px;

          flex-wrap: wrap;

        }


        .yk-primary-btn,
        .yk-secondary-btn {

          padding:
            13px 21px;

          font-family:
            Arial,
            sans-serif;

          font-size: 12px;

          cursor: pointer;

          transition:
            all .35s ease;

          display: flex;

          align-items: center;

          gap: 9px;

        }


        .yk-primary-btn {

          background:
            var(--gold);

          color:
            var(--navy);

          border:
            1px solid
            var(--gold);

          font-weight: bold;

        }


        .yk-primary-btn:hover {

          background:
            var(--gold-light);

          transform:
            translateY(-3px);

          box-shadow:
            0 12px 30px
            rgba(197,154,75,.2);

        }


        .yk-secondary-btn {

          background:
            transparent;

          border:
            1px solid
            rgba(255,255,255,.35);

          color: white;

        }


        .yk-secondary-btn:hover {

          border-color:
            var(--gold);

          color:
            var(--gold-light);

          transform:
            translateY(-3px);

        }


        /* =====================================================
           HERO STATS
           ===================================================== */

        .yk-hero-bottom {

          position: relative;

          z-index: 4;

          width: 100%;

          border-top:
            1px solid
            rgba(197,154,75,.25);

          display: grid;

          grid-template-columns:
            repeat(4,1fr);

          background:
            rgba(0,0,0,.15);

        }


        .yk-hero-bottom > div {

          padding:
            17px 20px;

          text-align: center;

          border-right:
            1px solid
            rgba(197,154,75,.2);

        }


        .yk-hero-bottom > div:last-child {
          border-right: none;
        }


        .yk-hero-bottom strong {

          display: block;

          color:
            var(--gold-light);

          font-size: 20px;

        }


        .yk-hero-bottom span {

          color:
            rgba(255,255,255,.6);

          font-family:
            Arial,
            sans-serif;

          font-size: 9px;

          letter-spacing: 1px;

        }


        /* =====================================================
           MAIN
           ===================================================== */

        .yk-main {

          position: relative;

          z-index: 2;

          width: 100%;

          max-width: 1450px;

          margin: auto;

          padding:
            100px
            clamp(20px,5vw,70px);

        }


        /* =====================================================
           REVEAL
           ===================================================== */

        .yk-reveal {

          opacity: 0;

          transform:
            translateY(45px);

          transition:
            opacity .8s ease,
            transform .8s ease;

        }


        .yk-reveal.yk-visible {

          opacity: 1;

          transform:
            translateY(0);

        }


        /* =====================================================
           SHOWCASE
           ===================================================== */

        .yk-showcase-heading {

          display: flex;

          align-items: center;

          justify-content: center;

          gap: 30px;

          margin-bottom: 45px;

        }


        .yk-gold-line {

          width: 100px;

          height: 1px;

          background:
            var(--gold);

        }


        .yk-mini-label {

          display: block;

          color:
            var(--gold);

          font-family:
            Arial,
            sans-serif;

          font-size: 9px;

          letter-spacing: 3px;

          text-align: center;

          margin-bottom: 8px;

        }


        .yk-showcase-heading h2 {

          text-align: center;

          margin: 0;

          font-size:
            clamp(30px,4vw,46px);

          line-height: 1.05;

          font-weight: normal;

          color:
            var(--navy);

        }


        .yk-showcase-heading h2 span {

          color:
            var(--gold);

        }


        .yk-image-grid {

          display: grid;

          grid-template-columns:
            1.4fr 1fr 1fr;

          height: 470px;

          gap: 5px;

        }


        .yk-image-card {

          position: relative;

          overflow: hidden;

          cursor: pointer;

        }


        .yk-image-card img {

          width: 100%;

          height: 100%;

          object-fit: cover;

          transition:
            transform .8s
            cubic-bezier(.2,.7,.2,1);

        }


        .yk-image-card:hover img {

          transform:
            scale(1.08);

        }


        .yk-image-gradient {

          position: absolute;

          inset: 0;

          background:
            linear-gradient(
              transparent 35%,
              rgba(7,29,54,.9)
            );

        }


        .yk-image-content {

          position: absolute;

          left: 25px;

          bottom: 25px;

          color: white;

          transition:
            transform .4s ease;

        }


        .yk-image-card:hover
        .yk-image-content {

          transform:
            translateY(-7px);

        }


        .yk-image-content span {

          color:
            var(--gold-light);

          font-family:
            Arial,
            sans-serif;

          font-size: 9px;

          letter-spacing: 2px;

        }


        .yk-image-content h3 {

          margin: 5px 0 0;

          font-size: 27px;

          font-weight: normal;

        }


        /* =====================================================
           ABOUT
           ===================================================== */

        .yk-about-section {

          margin-top: 120px;

          display: grid;

          grid-template-columns:
            1.3fr .7fr;

          gap: 80px;

          align-items: center;

        }


        .yk-section-label {

          display: flex;

          align-items: center;

          gap: 10px;

          color:
            var(--gold);

          font-family:
            Arial,
            sans-serif;

          font-size: 10px;

          letter-spacing: 3px;

          margin-bottom: 20px;

        }


        .yk-section-label span {

          width: 45px;

          height: 1px;

          background:
            var(--gold);

        }


        .yk-about-left h2,
        .yk-strength-left h2 {

          font-size:
            clamp(34px,4vw,56px);

          line-height: 1.08;

          margin: 0 0 25px;

          color:
            var(--navy);

          font-weight: normal;

        }


        .yk-about-left h2 span,
        .yk-strength-left h2 span {

          display: block;

          color:
            var(--gold);

        }


        .yk-about-left p,
        .yk-strength-left p {

          max-width: 750px;

          font-family:
            Arial,
            sans-serif;

          font-size: 13px;

          line-height: 1.85;

          color:
            var(--muted);

          margin-bottom: 17px;

        }


        .yk-about-highlight {

          display: flex;

          align-items: center;

          gap: 15px;

          border-top:
            1px solid
            #ddd3c2;

          padding-top: 20px;

          margin-top: 25px;

        }


        .yk-highlight-icon {

          width: 45px;

          height: 45px;

          background:
            var(--navy);

          color:
            var(--gold);

          display: flex;

          align-items: center;

          justify-content: center;

          border-radius: 50%;

        }


        .yk-about-highlight strong {

          display: block;

          color:
            var(--navy);

          font-size: 14px;

          margin-bottom: 3px;

        }


        .yk-about-highlight span {

          font-family:
            Arial,
            sans-serif;

          color:
            var(--muted);

          font-size: 10px;

        }


        .yk-about-right {

          display: grid;

          grid-template-columns:
            1fr 1fr;

          border:
            1px solid
            #d9c9ad;

        }


        .yk-about-stat {

          min-height: 150px;

          padding: 20px;

          display: flex;

          flex-direction: column;

          justify-content: center;

          align-items: center;

          text-align: center;

          gap: 5px;

          border-right:
            1px solid
            #d9c9ad;

          border-bottom:
            1px solid
            #d9c9ad;

          transition:
            all .35s ease;

        }


        .yk-about-stat:nth-child(2),
        .yk-about-stat:nth-child(4) {

          border-right: none;

        }


        .yk-about-stat:nth-child(3),
        .yk-about-stat:nth-child(4) {

          border-bottom: none;

        }


        .yk-about-stat:hover {

          background:
            var(--navy);

          color: white;

          transform:
            scale(1.03);

          z-index: 2;

        }


        .yk-about-stat svg {

          color:
            var(--gold);

          font-size: 25px;

          margin-bottom: 8px;

        }


        .yk-about-stat strong {

          font-size: 11px;

          letter-spacing: 1px;

        }


        .yk-about-stat span {

          font-family:
            Arial,
            sans-serif;

          font-size: 8px;

          color:
            var(--muted);

        }


        .yk-about-stat:hover span {
          color: rgba(255,255,255,.65);
        }


        /* =====================================================
           PRODUCTS
           ===================================================== */

        .yk-products-section {

          margin-top: 140px;

        }


        .yk-section-heading-center {

          text-align: center;

          margin-bottom: 50px;

        }


        .yk-section-heading-center
        .yk-section-label {

          justify-content: center;

        }


        .yk-section-heading-center h2 {

          font-size:
            clamp(32px,4vw,52px);

          font-weight: normal;

          color:
            var(--navy);

          margin: 0;

        }


        .yk-section-heading-center h2 span {

          color:
            var(--gold);

        }


        .yk-products-grid {

          display: grid;

          grid-template-columns:
            1fr 1fr;

          gap: 25px;

        }


        .yk-product-card {

          background:
            #fff;

          border:
            1px solid
            #ddd3c2;

          overflow: hidden;

          transition:
            transform .4s ease,
            box-shadow .4s ease;

        }


        .yk-product-card:hover {

          transform:
            translateY(-10px);

          box-shadow:
            0 25px 60px
            rgba(7,29,54,.12);

        }


        .yk-product-image {

          height: 350px;

          position: relative;

          overflow: hidden;

        }


        .yk-product-image img {

          width: 100%;

          height: 100%;

          object-fit: cover;

          transition:
            transform .8s ease;

        }


        .yk-product-card:hover
        .yk-product-image img {

          transform:
            scale(1.07);

        }


        .yk-product-overlay {

          position: absolute;

          top: 20px;

          left: 20px;

        }


        .yk-product-overlay span {

          background:
            var(--navy);

          color: white;

          padding:
            7px 11px;

          font-family:
            Arial,
            sans-serif;

          font-size: 8px;

          letter-spacing: 2px;

        }


        .yk-product-body {

          padding:
            30px;

          position: relative;

        }


        .yk-product-number {

          position: absolute;

          right: 25px;

          top: 20px;

          font-size: 40px;

          color:
            rgba(197,154,75,.15);

          font-weight: bold;

        }


        .yk-product-body h3 {

          color:
            var(--navy);

          font-size: 29px;

          margin: 0 0 10px;

          font-weight: normal;

        }


        .yk-product-body p {

          font-family:
            Arial,
            sans-serif;

          font-size: 12px;

          line-height: 1.7;

          color:
            var(--muted);

          max-width: 500px;

        }


        .yk-product-features {

          margin-top: 20px;

          display: grid;

          gap: 10px;

        }


        .yk-product-features div {

          display: flex;

          align-items: center;

          gap: 9px;

          font-family:
            Arial,
            sans-serif;

          font-size: 10px;

          color:
            #3e4650;

        }


        .yk-product-features svg {

          color:
            var(--gold);

        }


        /* =====================================================
           ROLE
           ===================================================== */

        .yk-role-section {

          margin-top: 140px;

          background:
            var(--navy);

          color: white;

          padding:
            70px
            clamp(25px,6vw,90px);

          position: relative;

          overflow: hidden;

        }


        .yk-role-section::before {

          content: "";

          position: absolute;

          width: 500px;

          height: 500px;

          right: -250px;

          top: -250px;

          border:
            1px solid
            rgba(197,154,75,.3);

          border-radius: 50%;

        }


        .yk-role-heading {

          position: relative;

          z-index: 2;

        }


        .yk-role-heading > span {

          color:
            var(--gold-light);

          font-family:
            Arial,
            sans-serif;

          font-size: 9px;

          letter-spacing: 4px;

        }


        .yk-role-heading h2 {

          font-size:
            clamp(34px,4vw,55px);

          font-weight: normal;

          line-height: 1.08;

          margin:
            12px 0 0;

        }


        .yk-role-description {

          position: relative;

          z-index: 2;

          max-width: 620px;

          margin:
            25px 0 50px;

        }


        .yk-role-description p {

          color:
            rgba(255,255,255,.65);

          font-family:
            Arial,
            sans-serif;

          font-size: 13px;

          line-height: 1.8;

        }


        .yk-role-grid {

          position: relative;

          z-index: 2;

          display:
            grid;

          grid-template-columns:
            repeat(4,1fr);

          border-top:
            1px solid
            rgba(197,154,75,.3);

        }


        .yk-role-item {

          padding:
            30px 20px;

          display:
            flex;

          flex-direction:
            column;

          gap: 8px;

          border-right:
            1px solid
            rgba(197,154,75,.25);

          transition:
            background .35s ease;

        }


        .yk-role-item:last-child {

          border-right: none;

        }


        .yk-role-item:hover {

          background:
            rgba(197,154,75,.07);

        }


        .yk-role-item svg {

          color:
            var(--gold);

          font-size: 25px;

          margin-bottom: 8px;

        }


        .yk-role-item strong {

          color:
            white;

          font-size: 11px;

          letter-spacing: 1px;

        }


        .yk-role-item span {

          color:
            rgba(255,255,255,.55);

          font-family:
            Arial,
            sans-serif;

          font-size: 9px;

          line-height: 1.5;

        }


        /* =====================================================
           STRENGTH
           ===================================================== */

        .yk-strength-section {

          margin-top: 140px;

          display:
            grid;

          grid-template-columns:
            .9fr 1.1fr;

          gap: 100px;

          align-items:
            start;

        }


        .yk-strength-list {

          border-top:
            1px solid
            #d9cdb9;

        }


        .yk-strength-row {

          display:
            flex;

          gap: 18px;

          padding:
            20px 0;

          border-bottom:
            1px solid
            #d9cdb9;

          transition:
            transform .3s ease,
            padding-left .3s ease;

        }


        .yk-strength-row:hover {

          transform:
            translateX(8px);

          padding-left:
            8px;

        }


        .yk-strength-icon {

          width: 43px;

          height: 43px;

          flex-shrink: 0;

          border-radius: 50%;

          background:
            var(--navy);

          color:
            var(--gold);

          display:
            flex;

          align-items:
            center;

          justify-content:
            center;

        }


        .yk-strength-row strong {

          display:
            block;

          color:
            var(--navy);

          font-size: 13px;

          margin-bottom: 5px;

        }


        .yk-strength-row span {

          font-family:
            Arial,
            sans-serif;

          color:
            var(--muted);

          font-size: 10px;

        }


        /* =====================================================
           INDUSTRIES
           ===================================================== */

        .yk-industries-section {

          margin-top: 140px;

        }


        .yk-industry-grid {

          display:
            grid;

          grid-template-columns:
            repeat(5,1fr);

          gap: 12px;

        }


        .yk-industry-card {

          min-height: 190px;

          background:
            white;

          border:
            1px solid
            #ddd3c2;

          display:
            flex;

          flex-direction:
            column;

          align-items:
            center;

          justify-content:
            center;

          text-align:
            center;

          transition:
            all .4s ease;

        }


        .yk-industry-card:hover {

          background:
            var(--navy);

          transform:
            translateY(-8px);

          box-shadow:
            0 20px 45px
            rgba(7,29,54,.15);

        }


        .yk-industry-icon {

          width: 60px;

          height: 60px;

          border-radius: 50%;

          background:
            var(--navy);

          color:
            var(--gold);

          display:
            flex;

          align-items:
            center;

          justify-content:
            center;

          font-size: 22px;

          margin-bottom: 15px;

          transition:
            all .4s ease;

        }


        .yk-industry-card:hover
        .yk-industry-icon {

          background:
            var(--gold);

          color:
            var(--navy);

          transform:
            rotate(8deg)
            scale(1.08);

        }


        .yk-industry-card strong {

          color:
            var(--navy);

          font-size: 12px;

          letter-spacing: 1px;

        }


        .yk-industry-card span {

          color:
            var(--muted);

          font-family:
            Arial,
            sans-serif;

          font-size: 8px;

          margin-top: 4px;

        }


        .yk-industry-card:hover strong {

          color: white;

        }


        .yk-industry-card:hover span {

          color:
            rgba(255,255,255,.55);

        }


        /* =====================================================
           FINAL BANNER
           ===================================================== */

        .yk-final-banner {

          width: 100%;

          min-height: 230px;

          background:
            var(--navy);

          display:
            flex;

          align-items:
            center;

          justify-content:
            space-between;

          overflow:
            hidden;

          position:
            relative;

          border-top:
            1px solid
            var(--gold);

          border-bottom:
            1px solid
            var(--gold);

        }


        .yk-final-content {

          text-align:
            center;

          position:
            relative;

          z-index: 3;

          flex: 1;

        }


        .yk-final-small {

          color:
            var(--gold-light);

          font-family:
            Arial,
            sans-serif;

          font-size: 9px;

          letter-spacing: 4px;

        }


        .yk-final-content h2 {

          color:
            white;

          font-weight:
            normal;

          font-size:
            clamp(27px,4vw,46px);

          line-height:
            1.1;

          margin:
            12px 0;

        }


        .yk-final-content h2 strong {

          color:
            var(--gold-light);

          font-weight:
            normal;

        }


        .yk-final-content p {

          color:
            rgba(255,255,255,.55);

          font-family:
            Arial,
            sans-serif;

          font-size: 11px;

        }


        .yk-final-decoration-left,
        .yk-final-decoration-right {

          position:
            relative;

          width:
            250px;

          height:
            220px;

          flex-shrink:
            0;

        }


        .yk-final-decoration-left img:first-child {

          position:
            absolute;

          width:
            130px;

          left:
            5px;

          bottom:
            15px;

          animation:
            ykFloat 4s ease-in-out infinite;

        }


        .yk-final-decoration-left img:last-child {

          position:
            absolute;

          width:
            170px;

          left:
            80px;

          bottom:
            0;

          animation:
            ykFloat 4s .5s ease-in-out infinite;

        }


        .yk-final-decoration-right img:first-child {

          position:
            absolute;

          width:
            120px;

          right:
            90px;

          bottom:
            35px;

        }


        .yk-final-decoration-right img:last-child {

          position:
            absolute;

          width:
            160px;

          right:
            0;

          bottom:
            5px;

          animation:
            ykFloat 4s 1s ease-in-out infinite;

        }


        @keyframes ykFloat {

          0%,100% {

            transform:
              translateY(0);

          }

          50% {

            transform:
              translateY(-8px);

          }

        }


        /* =====================================================
           FOOTER
           ===================================================== */

        .yk-footer {

          background:
            #f8f5ee;

          width:
            100%;

          border-bottom:
            5px solid
            var(--gold);

        }


        .yk-footer-inner {

          min-height:
            100px;

          max-width:
            1600px;

          margin:
            auto;

          padding:
            0
            clamp(20px,5vw,70px);

          display:
            flex;

          align-items:
            center;

          gap:
            25px;

          position:
            relative;

          overflow:
            hidden;

        }


        .yk-footer-number {

          width:
            90px;

          height:
            100px;

          background:
            var(--gold);

          color:
            var(--navy);

          display:
            flex;

          align-items:
            center;

          justify-content:
            center;

          font-size:
            38px;

          font-weight:
            bold;

        }


        .yk-footer-company {

          display:
            flex;

          flex-direction:
            column;

          gap:
            4px;

        }


        .yk-footer-company strong {

          color:
            var(--navy);

          font-family:
            Arial,
            sans-serif;

          font-size:
            14px;

        }


        .yk-footer-company span {

          color:
            var(--gold);

          font-family:
            Arial,
            sans-serif;

          font-size:
            10px;

        }


        .yk-footer-divider {

          width:
            1px;

          height:
            45px;

          background:
            #d5c6ab;

          margin-left:
            auto;

        }


        .yk-footer-link {

          display:
            flex;

          align-items:
            center;

          gap:
            8px;

          color:
            var(--navy);

          text-decoration:
            none;

          font-family:
            Arial,
            sans-serif;

          font-size:
            11px;

          font-weight:
            bold;

          transition:
            color .3s ease;

          z-index:
            2;

        }


        .yk-footer-link:hover {

          color:
            var(--gold);

        }


        .yk-footer-link svg {

          font-size:
            19px;

        }


        .yk-footer-map {

          position:
            absolute;

          right:
            0;

          width:
            190px;

          opacity:
            .15;

          z-index:
            1;

        }


        /* =====================================================
           LARGE TABLET
           ===================================================== */

        @media (max-width: 1100px) {

          .yk-hero-content {

            gap:
              40px;

          }


          .yk-logo-ring {

            width:
              200px;

            height:
              200px;

          }


          .yk-hero-brand {

            gap:
              20px;

          }


          .yk-brand-title {

            font-size:
              21px;

          }


          .yk-image-grid {

            height:
              390px;

          }


          .yk-about-section {

            gap:
              45px;

          }


          .yk-strength-section {

            gap:
              50px;

          }

        }


        /* =====================================================
           TABLET
           ===================================================== */

        @media (max-width: 850px) {

          .yk-hero {

            min-height:
              auto;

          }


          .yk-hero-content {

            grid-template-columns:
              1fr;

            text-align:
              center;

            padding:
              70px 25px;

          }


          .yk-hero-brand {

            justify-content:
              center;

          }


          .yk-hero-text {

            margin:
              auto;

          }


          .yk-eyebrow {

            justify-content:
              center;

          }


          .yk-hero-text p {

            margin-left:
              auto;

            margin-right:
              auto;

          }


          .yk-hero-actions {

            justify-content:
              center;

          }


          .yk-image-grid {

            grid-template-columns:
              1fr 1fr;

            height:
              600px;

          }


          .yk-image-large {

            grid-column:
              span 2;

          }


          .yk-about-section {

            grid-template-columns:
              1fr;

          }


          .yk-products-grid {

            grid-template-columns:
              1fr;

          }


          .yk-role-grid {

            grid-template-columns:
              1fr 1fr;

          }


          .yk-role-item:nth-child(2) {

            border-right:
              none;

          }


          .yk-strength-section {

            grid-template-columns:
              1fr;

          }


          .yk-industry-grid {

            grid-template-columns:
              repeat(3,1fr);

          }


          .yk-industry-card:nth-child(4) {

            grid-column:
              span 1;

          }


          .yk-final-decoration-left,
          .yk-final-decoration-right {

            width:
              170px;

          }

        }


        /* =====================================================
           MOBILE
           ===================================================== */

        @media (max-width: 600px) {

          .yk-topbar-label {

            display:
              none;

          }


          .yk-topbar-inner {

            justify-content:
              center;

          }


          .yk-hero-content {

            padding:
              55px 18px;

          }


          .yk-hero-brand {

            flex-direction:
              column;

          }


          .yk-logo-ring {

            width:
              180px;

            height:
              180px;

          }


          .yk-brand-small {

            font-size:
              11px;

          }


          .yk-brand-title {

            font-size:
              23px;

          }


          .yk-hero-text h1 {

            font-size:
              36px;

          }


          .yk-hero-text p {

            font-size:
              12px;

          }


          .yk-hero-bottom {

            grid-template-columns:
              1fr 1fr;

          }


          .yk-hero-bottom > div {

            border-bottom:
              1px solid
              rgba(197,154,75,.2);

          }


          .yk-main {

            padding:
              65px 16px;

          }


          .yk-showcase-heading {

            gap:
              10px;

          }


          .yk-gold-line {

            width:
              25px;

          }


          .yk-image-grid {

            display:
              flex;

            flex-direction:
              column;

            height:
              auto;

          }


          .yk-image-card {

            height:
              250px;

          }


          .yk-image-large {

            height:
              300px;

          }


          .yk-about-section,
          .yk-products-section,
          .yk-role-section,
          .yk-strength-section,
          .yk-industries-section {

            margin-top:
              85px;

          }


          .yk-about-right {

            margin-top:
              15px;

          }


          .yk-about-stat {

            min-height:
              125px;

          }


          .yk-product-image {

            height:
              280px;

          }


          .yk-product-body {

            padding:
              22px;

          }


          .yk-role-section {

            padding:
              50px 20px;

          }


          .yk-role-grid {

            grid-template-columns:
              1fr;

          }


          .yk-role-item {

            border-right:
              none;

            border-bottom:
              1px solid
              rgba(197,154,75,.25);

          }


          .yk-role-item:last-child {

            border-bottom:
              none;

          }


          .yk-industry-grid {

            grid-template-columns:
              1fr 1fr;

          }


          .yk-industry-card {

            min-height:
              160px;

          }


          .yk-final-banner {

            min-height:
              270px;

          }


          .yk-final-decoration-left,
          .yk-final-decoration-right {

            display:
              none;

          }


          .yk-final-content {

            padding:
              25px;

          }


          .yk-footer-inner {

            min-height:
              160px;

            flex-wrap:
              wrap;

            padding:
              15px;

            gap:
              12px;

          }


          .yk-footer-number {

            width:
              60px;

            height:
              60px;

            font-size:
              25px;

          }


          .yk-footer-divider {

            display:
              none;

          }


          .yk-footer-link {

            width:
              100%;

          }


          .yk-footer-map {

            width:
              150px;

            right:
              -20px;

            bottom:
              0;

          }

        }


        /* =====================================================
           SMALL MOBILE
           ===================================================== */

        @media (max-width: 400px) {

          .yk-hero-text h1 {

            font-size:
              31px;

          }


          .yk-brand-title {

            font-size:
              20px;

          }


          .yk-hero-bottom strong {

            font-size:
              16px;

          }


          .yk-hero-bottom span {

            font-size:
              7px;

          }


          .yk-section-heading-center h2 {

            font-size:
              30px;

          }


          .yk-about-left h2,
          .yk-strength-left h2 {

            font-size:
              33px;

          }


          .yk-industry-grid {

            gap:
              7px;

          }


          .yk-industry-card {

            min-height:
              140px;

          }


          .yk-industry-icon {

            width:
              48px;

            height:
              48px;

            font-size:
              18px;

          }

        }


        /* =====================================================
           REDUCED MOTION
           ===================================================== */

        @media (prefers-reduced-motion: reduce) {

          *,
          *::before,
          *::after {

            animation-duration:
              .01ms !important;

            animation-iteration-count:
              1 !important;

            scroll-behavior:
              auto !important;

            transition-duration:
              .01ms !important;

          }

        }

      `}</style>

    </div>
  );
}